import * as React from 'react';

const ExportMgr = React.lazy(() => import('./container'));

export default () => <ExportMgr />;
